import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const ReleasesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 36px;

  @media (max-width: 1425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const PodcastsTitleSkeleton = styled.h1`
  width: 285px;
  height: 75px;

  @media ${breakpoints.sm} {
    height: 60px;
  }

  @media ${breakpoints.xs} {
    height: 32px;
  }
`;

export const ReleaseTitleSkeleton = styled.h2`
  width: 410px;
  height: 75px;

  @media ${breakpoints.sm} {
    width: 285px;
    height: 60px;
  }

  @media ${breakpoints.xs} {
    width: 285px;
    height: 32px;
  }
`;
